<script setup lang="ts">
import { computed, reactive } from 'vue'
import { useInternalScenarioChatFormStore } from './form/form'

const formStore = reactive(useInternalScenarioChatFormStore())

const value = computed(() => formStore.formValues.title)

const handleInput = (e: Event) => {
  formStore.formValues.title = (e.target as HTMLInputElement).value
}
</script>

<template>
  <input
    type="text"
    :value="value"
    @input="handleInput"
    :class="{
      [$style.input]: true,
    }"
    placeholder="シナリオチャットのタイトルを入力する..."
  />
</template>

<style lang="scss" module>
.input {
  font-size: 18px;
  font-weight: 700;
  padding: 4px 8px;
  border-radius: 8px;
  height: 32px;
  width: 100%;

  &:focus {
    outline: none;
  }
}
</style>
